import {MutationTree} from "vuex";
import * as moment from "moment";
import CacheHash from "../ts/CacheItemInterface";

export const mutations: MutationTree<any> = {

    /**
     * Panel stats
     */

    setPanelStats(state: any, payload: any) {
        state.panelStats = payload;
    },

    setPanelFilters(state: any, payload: any) {
        state.panelFilters = JSON.parse(JSON.stringify(payload));
    },

    setPanelReportingMode(state: any, payload: boolean) {
        state.panelReportingMode = payload;
    },

    /**
     * Recruitment sources
     */

    setRecruitmentStats(state: any, payload: any) {
        state.recruitmentStats = payload;
    },

    setRecruitmentFilters(state: any, payload: any) {
        state.recruitmentFilters = payload;
    },

    setRecruitmentReportingMode(state: any, payload: boolean) {
        state.recruitmentReportingMode = payload;
    },

    /**
     * Sub panels
     */

    setSubPanelStats(state: any, payload: any) {
        state.subPanelStats = payload;
    },

    setSubPanelFilters(state: any, payload: any) {
        state.subPanelFilters = payload;
    },

    setSubPanelReportingMode(state: any, payload: boolean) {
        state.subPanelReportingMode = payload;
    },

    /**
     * Common
     */

    setLoading(state: any, payload: boolean) {
        state.loading = payload;
    },

    setCacheItem(state: any, {hash, data}) {
        const found = state.cache.find( (cache: CacheHash) => cache.hash === hash);

        if (!found) {
            let cache: CacheHash = {
                hash: hash,
                expires: moment().add(240, 'minutes'),
                item: data
            }
            state.cache.push(cache)
        }
    },

    clearFinancialCache(state: any) {
        state.cache = [];
    }
};
